import type { EstimateResponse, LatLng } from "../types/journey";

export type EstimateRequest = {
  origin: LatLng;
  destination: LatLng;
  passengerCount: number;
  leaveNow?: boolean;
  travelTime?: string;
};

const API_BASE = import.meta.env.VITE_API_BASE_URL;

export async function estimateRoute(payload: EstimateRequest): Promise<EstimateResponse> {
  const res = await fetch(`${API_BASE}/estimation-service/estimate`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(payload),
  });

  if (!res.ok) {
    throw new Error(`Estimate failed: ${res.status}`);
  }

  return res.json();
}
